import dotProp from 'dot-prop-immutable';

import * as sharedTypes from 'shared/redux/actionTypes';

import * as types from '../actionTypes';

const defaultState = {
  urlsByCriteria: {},
  errorsByCriteria: {},
  isLoading: false,
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REQUEST_COUPON_URL:
      return dotProp.set(state, 'isLoading', true);

    case types.RECEIVE_COUPON_URL: {
      const {
        meta: { criteria },
        payload: url,
      } = action;

      const errorsByCriteria = { ...state.errorsByCriteria };
      delete errorsByCriteria[criteria];

      return {
        ...state,
        isLoading: false,
        errorsByCriteria,
        urlsByCriteria: {
          ...state.urlsByCriteria,
          [criteria]: url,
        },
      };
    }

    case types.RECEIVE_COUPON_URL_ERROR: {
      const {
        meta: { criteria },
        payload: error,
      } = action;

      const urlsByCriteria = { ...state.urlsByCriteria };
      delete urlsByCriteria[criteria];

      return {
        ...state,
        isLoading: false,
        urlsByCriteria,
        errorsByCriteria: {
          ...state.errorsByCriteria,
          [criteria]: error,
        },
      };
    }

    case types.CLEAR_COUPONS:
    case sharedTypes.DELETE_USER:
      return defaultState;

    default:
      return state;
  }
}
